// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"zO","product":"AO","products":"BO","tooltipWrapper":"CO","tooltip":"DO","title":"EO"};